<template>
	<div class="position-absolute d-flex top-50 start-50 translate-middle">
		<div class="p-2 rounded-circle ball" :class="{
			'bg-dark border border-2 border-white' : !invert,
			'bg-white border border-2 border-dark': invert
		}"></div>
		<div class="p-2 rounded-circle filled-ball" :class="{
			'bg-white border border-2 border-white' : !invert,
			'bg-dark border border-2 border-dark': invert
		}"></div>
	</div>
</template>
<script>
export default {
	props: {
		invert: Boolean
	}
}
</script>
<style scoped>
.ball {
	animation-name: ballAnim;
	animation-duration: 1.4s;
	animation-fill-mode: forwards;
	animation-iteration-count: infinite;
}
.filled-ball {
	animation-name: filledBallAnim;
	animation-duration: 1.4s;
	animation-fill-mode: forwards;
	animation-iteration-count: infinite;
}

@keyframes ballAnim {
	0% {
		transform: translateX(0%);
		z-index: 1;
	}
	49% {
		z-index: 1;
	}
	50% {
		transform: translateX(100%);
		z-index: 0;
	}
	100% {
		transform: translateX(0%);
		z-index: 0;
	}
}

@keyframes filledBallAnim {
	0% {
		transform: translateX(0%);
	}
	50% {
		transform: translateX(-100%);
	}
	100% {
		transform: translateX(0%);
	}
}
</style>